import React, { useState, } from 'react';
import './auth.scss';
import logo from '@Assets/graphic/logo.png';
import { MailIcon, } from '@Assets/icons';
import { Button, Input, } from 'antd';
import { useTranslation, } from 'react-i18next';
import { apiRequestResetPassword, } from '@Api';
import { AlertError, InfoModal, preventDefault, } from '@Utils';

export const RequestResetPasswordContainer = React.memo(() => {
  const { t, } = useTranslation();
  const [loading, ] = useState(false);
  const [errors, ] = useState<Array<string>>([]);
  const [username, setUsername, ] = useState<string>('');
  // const handleKeyDown = (e: React.KeyboardEvent) => e.key === 'Enter' && reset();

  const reset = async () => {
    valid && apiRequestResetPassword(username)
      .then(msg => InfoModal(t, { content: t(msg || 'PASSWORD_RESET_REQUEST_SUCCESSFUL'), }))
      .catch(error => AlertError(t, { content: t(error || 'PLEASE_TRY_AGAIN_LATER'), }));
  };

  const valid = username && username.length > 2;

  return (
    <>
      <div className={'login-bg'}></div>
      <div className={'login-wrp'}>
        <div className={'logo-wrp'} >
          <img src={logo} alt={'Logo'} />
        </div>

        <div className={'form-wrp'}>
          <form onSubmit={preventDefault(reset)}>
            <div className={'form-row'} >
              <span className={'auth-or-txt'}>
                {t('FILL_USERNAME_TO_RESET_PASSWORD')}
              </span>
            </div>
            <div className={'form-row column-dir'} >
              <label className={'form-label'} htmlFor="email">
                {t('USERNAME')}
              </label>
              <div className={'input-wrp'} >
                <Input
                  size="large"
                  name="username"
                  onChange={e => setUsername(e.target.value)}
                  className={'auth-input'}
                  placeholder=""
                  prefix={<MailIcon size={24} />}
                  autoFocus={true}
                />
              </div>
            </div>
            <div className={'form-row'} >
              <Button loading={loading} onClick={reset} className={'reset-submit-btn'} type="primary" disabled={!valid}>{t('RESET_PASSWORD')}</Button>
            </div>
            <div className={'form-row'} >
              <ul className={'form-error-wrp'}>
                {
                  errors?.map((e, i) => <li key={i}>{e}</li>)
                }
              </ul>
            </div>
          </form>
        </div>

      </div>
    </>
  );
});
